import { ModuleLayout } from '@billy/design-system'
import type { HelpCenterLayoutSlots } from '@shinetools/virtual-assistant-client'
import { ReactElement } from 'react'

import { HelpCenter, VirtualAssistantHost } from '@features/virtualAssistant'

import { ThemeProvider } from '../../../contexts/themeProvider'

const renderModuleLayout = ({ content, sideActions, title }: HelpCenterLayoutSlots): ReactElement => (
  <ThemeProvider>
    <ModuleLayout sideActions={sideActions} title={title}>
      {content}
    </ModuleLayout>
  </ThemeProvider>
)

export const HelpCenterPage = (): ReactElement => (
  <VirtualAssistantHost>
    <HelpCenter renderLayout={renderModuleLayout} />
  </VirtualAssistantHost>
)
